import ev from "../util/enumValue";

enum ProductSubtitlePosition {
    BELOW = ev('BELOW', 1),
    NEXT = ev('NEXT', 2)
}

export default ProductSubtitlePosition;
